export const TableSort = {
  asc: 'asc',
  desc: 'desc',
};
